import getConfig from "next/config"

const config = getConfig()

interface PublicEnvVars {
    ENVIRONMENT: string
    GRAPHQL_SERVER_URL: string
    APP_URL: string
    ACCOUNT_ASSETS_URL: string
    COGNITO_IDENTITY_POOL_ID: string
    COGNITO_USER_POOL_ID: string
    COGNITO_CLIENT_ID: string
    GOOGLE_API_KEY: string
    GOOGLE_OAUTH_CLIENT_ID: string
    FACEBOOK_LOGIN_APP_ID: string
    HOTJAR_ID: string
    GOOGLE_ANALYTICS_ID: string
    NODE_ENV: string
    BUGSNAG_API_KEY: string
    GOOGLE_RECAPTCHA_KEY: string
}

interface ServerEnvVars {
    GOOGLE_OAUTH_SECRET: string
}

export const publicEnvVars: PublicEnvVars = config ? config.publicRuntimeConfig : {}
export const serverEnvVars: ServerEnvVars = config ? config.serverRuntimeConfig : {}
